/* unplugin-vue-components disabled */import script from "./navLeftNotice.vue?vue&type=script&setup=true&lang=js"
export * from "./navLeftNotice.vue?vue&type=script&setup=true&lang=js"

import "./navLeftNotice.vue?vue&type=style&index=0&id=c6998a24&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c6998a24"]])

export default __exports__